const genderTypes = [
  {
    value: '',
    title: 'Tots'
  },
  {
    value: 'M',
    title: 'Masculí'
  },
  {
    value: 'F',
    title: 'Femení'
  }
]

const paymentTypes = [
  { value: 'CLUB', title: 'Club', text: 'Club' },
  { value: 'TRANSFERENCIA', title: 'Transferencia', text: 'Transferencia' },
  {
    value: 'RECIBO BANCARIO',
    title: 'Recibo bancario',
    text: 'Recibo bancario'
  },
  { value: 'MONEDERO', title: 'Monedero', text: 'Monedero' },
  { value: 'BIZUM', title: 'Bizum', text: 'Bizum' },
  { value: 'CONTADO', title: 'Contado', text: 'Contado' },
  { value: 'TPV', title: 'TPV', text: 'TPV' }
]

const categoryTypes = [
  { value: 'JUN', title: 'Junior', text: 'Junior' },
  { value: 'SEN', title: 'Adult', text: 'Adult' },
  { value: 'QUI', title: 'Quinzenal  Menors', text: 'Quinzenal  Menors' },
  { value: 'TRI', title: 'Trimestral', text: 'Trimestral' },
  { value: 'ALE', title: 'Alevi', text: 'Alevi' },
  { value: 'BEN', title: 'Benjami', text: 'Benjami' },
  { value: 'INF', title: 'Infantil', text: 'Infantil' },
  { value: 'CAD', title: 'Cadet', text: 'Cadet' }
]

const licenseTypes = [
  { value: 'normal', text: 'Anual', title: 'Anual' },
  { value: 'torneo', text: 'Torneig', title: 'Torneig' },
  { value: 'cuatrimestral', text: 'Quadrimestral', title: 'Quadrimestral' },
  { value: 'adaptada', text: 'Pàdel adaptat', title: 'Pàdel adaptat' },
  { value: 'cadira', text: 'Pàdel en cadira', title: 'Pàdel en cadira' }
]

//   { value: 'TRM', title: 'Trimestral Menors' },
//   { value: 'SET', title: 'Adult Setmanal' },
//   { value: 'JAB', title: 'Jutge Arbitre' },
//   { value: 'QUA', title: 'QUADRIMESTRAL ADULT' },
//   { value: 'QUM', title: 'QUADRIMESTRAL MENOR' },
//   { value: 'ADA', title: 'ADAPTADA' },
//   { value: 'SOC', title: 'SOCIAL' },
//   { value: 'SEM', title: 'Menors Setmanal' },
//   { value: 'ESC', title: 'ESCOLAR' },
//   { value: 'UNI', title: 'Setmanal Uni' },
//   { value: 'SIL', title: 'SILLA' }
// ]

const torsCats = [
  {
    name: 'Circuit Absolut',
    id: 'catala',
    keyword: 'absolut',
    keywordList: ['absolut'],
    name: 'Circuit Absolut',
    torUrl: '/competicio/circuits/circuit-absolut',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Absolut_Cupra_96566b01a8.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Absolut_Cupra_Ficha_Torneo_ed6a23844e.jpg',
    color: 'sec-red',
    filters: ['Absolut'],
    categoryHasLocation: false,
    newsCat: 'Absolut'
  },
  {
    id: 'menores',
    keyword: 'menores',
    keywordList: ['menors', 'menores'],
    name: 'Circuit de Menors',
    torUrl: '/competicio/circuits/circuit-menors',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_de_Menors_55bf829ef4.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_de_Menors_Ficha_Torneo_e23f62d0f7.jpg',
    color: 'sec-blue',
    filters: ['Alevi', 'Benjami', 'Cadet', 'Infantil', 'Junior'],
    categoryHasLocation: true,
    newsCat: 'Menors'
  },
  {
    id: 'menores',
    poster: 'joves-promeses',
    keyword: 'menores',
    keywordList: ['menors', 'menores'],
    name: 'Circuit Joves Promeses',
    torUrl: '/competicio/circuits/circuit-joves-promeses',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/Menors_Hospitalet_179_7a72924930.JPG',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/Menors_Hospitalet_179_7a72924930.JPG',
    color: 'sec-dark-blue',
    filters: ['Alevi', 'Benjami', 'Cadet', 'Infantil', 'Junior'],
    categoryHasLocation: true,
    newsCat: 'Menors'
  },
  {
    id: 'bronze',
    keyword: 'open',
    keywordList: ['open'],
    name: 'Circuit Open',
    torUrl: '/competicio/circuits/circuit-open',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Open_Head_1f5d66bb8a.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Open_Head_Ficha_Torneo_78f0324e4d.jpg',
    color: 'sec-yellow',
    filters: ['OPEN'],
    categoryHasLocation: true,
    newsCat: 'Open'
  },
  {
    id: 'senior',
    keyword: 'veteranos',
    keywordList: ['veterans', 'veteranos'],
    name: 'Circuit de Veterans',
    torUrl: '/competicio/circuits/circuit-veterans',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_de_Veterans_28b36cab1c.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_de_Veterans_Ficha_Torneo_cac9677964.jpg',
    color: 'sec-orange',
    filters: [
      'Veterans +35',
      'Veterans +40',
      'Veterans +45',
      'Veterans +50',
      'Veterans +55'
    ],
    categoryHasLocation: false,
    newsCat: 'Sènior'
  },
  {
    id: 'senior',
    keyword: 'veteranos',
    keywordList: ['veterans', 'veteranos'],
    name: 'Circuit de Veterans',
    torUrl: '/competicio/circuits/circuit-veterans',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_de_Veterans_28b36cab1c.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_de_Veterans_Ficha_Torneo_cac9677964.jpg',
    color: 'sec-orange',
    filters: [
      'Veterans +35',
      'Veterans +40',
      'Veterans +45',
      'Veterans +50',
      'Veterans +55'
    ],
    categoryHasLocation: false,
    newsCat: 'Veterans'
  },
  { id: 'provincial', keyword: 'provincial' },
  {
    id: 'silla',
    keyword: 'silla',
    keywordList: ['silla', 'cadira'],
    name: 'Circuit de Pàdel en Cadira',
    torUrl: '/competicio/circuits/circuit-padel-cadira',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_en_cadira_cda0e7054d.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_en_cadira_Ficha_Torneo_667f500c0a.jpg',
    color: 'grey',
    filters: ['Cadira'],
    categoryHasLocation: false,
    newsCat: 'Cadira'
  },
  {
    id: 'universitari',
    keyword: 'universitari',
    keywordList: ['universitari'],
    name: 'Circuit de Pàdel Universitari',
    torUrl: '/competicio/circuits/circuit-universitari',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Universitari_869447c143.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Universitari_Ficha_Torneo_87b7c74aee.jpg',
    color: 'sec-green',
    filters: ['Universitari'],
    categoryHasLocation: false,
    newsCat: 'Universitari'
  },
  {
    name: 'Lliga Catalana BULLPADEL',
    torUrl: '/competicio/lligues/lliga-catalana',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Lliga_Catalana_Bullpadel_i_Interclubs_Senior_85a13eb9c1.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Universitari_Ficha_Torneo_87b7c74aee.jpg',
    color: 'sec-cream',
    containsSecNav: true,
    filters: '',
    newsCat: 'Lliga Catalana',
    urlToName: {
      absoluta: 'Lliga Catalana Absoluta',
      veterans: 'Lliga Catalana de Veterans',
      menors: 'Lliga Catalana de Menors'
    }
  },
  {
    name: 'Lliga Interclubs',
    torUrl: '/competicio/lligues/interclubs',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Lliga_Catalana_Bullpadel_i_Interclubs_Senior_85a13eb9c1.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Universitari_Ficha_Torneo_87b7c74aee.jpg',
    color: 'sec-green',
    containsSecNav: true,
    filters: '',
    newsCat: 'Lliga Catalana',
    urlToName: {
      femeni: 'Interclubs Femeni',
      senior: 'Interclubs Barcelona'
    }
  },
  {
    name: 'Interclubs Femení RACC',
    torUrl: '/competicio/lligues/interclubs/femeni',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Interclubs_Femeni_019922ccb0.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Universitari_Ficha_Torneo_87b7c74aee.jpg',
    color: 'sec-green'
  },
  {
    name: 'Interclubs Sènior',
    torUrl: '/competicio/lligues/interclubs/senior',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Lliga_Catalana_Bullpadel_i_Interclubs_Senior_85a13eb9c1.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Universitari_Ficha_Torneo_87b7c74aee.jpg',
    color: 'sec-green'
  },
  {
    name: "Lliga Catalana d'Escoles",
    torUrl: '/competicio/lligues/escoles-menors',
    headerImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Lliga_d_Escoles_de_Menors_55a2de5e67.jpg',
    cardImg:
      'https://fcp-site-images.s3.eu-west-3.amazonaws.com/3_Circuit_Universitari_Ficha_Torneo_87b7c74aee.jpg',
    color: 'sec-green'
  }
  // { id: 'master', keyword: 'màster' },
]

const provinces = [
  {
    title: 'Barcelona',
    value: 'Barcelona'
  },
  {
    title: 'Girona',
    value: 'Girona'
  },
  {
    title: 'Lleida',
    value: 'Lleida'
  },
  {
    title: 'Tarragona',
    value: 'Tarragona'
  }
]

// transProcessTeams for /processar-equips
const paymentMsgs = {
  domiciliacion:
    "En cas de domiciliació bancària, el número de compte serà l'informat a la pestanya de 'Dades Bancàries', dins de 'Dades Econòmiques'. <u>Pots comprovar-lo a dalt o introduir-ne un de nou</u>. La domiciliació es realitzarà a la vista. Per a qualsevol dubte, contacteu amb administracio@fcpadel.cat",
  transferencia:
    'En cas de transferència, la data límit de pagament és de 30 dies naturals. El número de compte de la FCP és el següent: IBAN: ES44 2100 0815 5402 0073 6301 Per a qualsevol dubte, contacteu amb administracio@fcpadel.cat',
  transProcessTeams:
    "En cas de transferència anticipada, s'ha de fer la transferència abans de continuar i adjuntar el justificant de pagament. El número de compte de la FCP és el següent: IBAN: ES44 2100 0815 5402 0073 6301 Per a qualsevol dubte, contacteu amb administracio@fcpadel.cat",
  successful:
    "Les llicències s'han tramitat i activat correctament. La factura s'emetrà dins els propers dies i la tindreu disponible a la pestanya de 'Dades Econòmiques'"
}

export {
  genderTypes,
  paymentTypes,
  categoryTypes,
  licenseTypes,
  torsCats,
  provinces,
  paymentMsgs
}
